import styled from '@emotion/styled';

const Container = styled('div')(({ theme }) => ({
  backgroundColor: theme.colors.gray['100'],
  position: 'relative',
}));

export default Container;
